import { render } from "./DcaOrderList.vue?vue&type=template&id=6de68b56&scoped=true"
import script from "./DcaOrderList.vue?vue&type=script&lang=js"
export * from "./DcaOrderList.vue?vue&type=script&lang=js"

import "./DcaOrderList.vue?vue&type=style&index=0&id=6de68b56&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de68b56"],['__file',"resources/js/components/DcaOrderList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6de68b56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6de68b56', __exports__)) {
    api.reload('6de68b56', __exports__)
  }
  
  module.hot.accept("./DcaOrderList.vue?vue&type=template&id=6de68b56&scoped=true", () => {
    api.rerender('6de68b56', render)
  })

}


export default __exports__